import { request } from "@/utils/request";
import useSWR from "swr";

interface ResponseZkStarter {
  id: number;
  code: string;
  name: string;
  url: string;
  status: string;
  alias: string;
  desc: string | null;
  createdAt: string;
  updatedAt: string;
  imageUrl: string;
  totalUser: number;
  totalStaked: string | null;
  chainId: number;
  raiseToken: string | null;
  athRoi: string;
  totalCommitTokens: string;
}

async function fetchZkStarter(url: string) {
  const response = await request(url);
  const data = await response.json();
  return data as ResponseZkStarter[];
}

export function useZkStarter() {
  const data = useSWR("https://gateway.holdstation.com/services/launchpad/api/projects", fetchZkStarter, {
    refreshInterval: 15_000,
    errorRetryInterval: 10_000,
  });

  return data;
}
